import React, {FC} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {Icon, IconName} from '../../../../../../../libs/shared/ui/src/components/icon/icon';

/*
 * Props.
 */

interface MessageViewerActionProps {
  iconName: IconName;
  isDisabled?: boolean;
  onClick?: Handler;
}

/*
 * Style.
 */

const StyledActionDiv = styled.div`
  display: grid;
  grid-template-areas: 'icon text';
  align-items: center;
  grid-column-gap: 6px;
`;

const StyledIconDiv = styled(Icon)`
  grid-area: icon;
  margin: -2px 0;
  transform: translateY(0.5px);
`;

const StyledTextDiv = styled.div`
  grid-area: text;
  margin-right: 4px;
`;

/*
 * Component.
 */

export const MessageViewerAction: FC<MessageViewerActionProps> = (props) => (
  <Button
    variant={ButtonVariantsEnum.PRIMARY}
    isDisabled={props.isDisabled}
    onClick={() => onClick(props)}
    interactionId={`message-viewer-action-${props.iconName}`}
  >
    <StyledActionDiv>
      <StyledIconDiv name={props.iconName} />
      <StyledTextDiv>{props.children}</StyledTextDiv>
    </StyledActionDiv>
  </Button>
);

function onClick(props: MessageViewerActionProps) {
  if (!props.isDisabled && props.onClick) {
    props.onClick();
  }
}
